<template>
  <div id="add-new-order-modal">
    <v-layout row justify-center>
      <v-dialog v-model="giveToCustomerModal" persistent max-width="25%">
        <v-card>
          <form action="" @submit.prevent="submitForm()">
            <v-card-title>
              <div class="col-sm-10"><span class="headline">{{ $t('giveToCustomer.title') }}</span></div>
              <div class="col-sm-2">
                <v-btn flat @click="closeGiveToCustomerModal" class="close"><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </div>
            </v-card-title>
            <v-card-text>
              <v-alert type="success" :value="checkAlert">
                {{ $t('giveToCustomer.givenSuccessfully') }}
              </v-alert>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md3>
                    <v-select
                      autocomplete
                      :items="customers"
                      item-value="value"
                      v-model="giveData.customer_id_fk"
                      :error-messages="errors.collect('Customer')"
                      data-vv-name="Customer"
                      :label="$t('columns.customer')"
                      v-validate="'required'"
                      single-line
                    >
                    </v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="height:auto" @click="closeGiveToCustomerModal" outline color="normal"
                >{{ $t('common.cancel') }}</v-btn
              >
              <v-btn type="submit" style="height:auto" class="rtl-mr-6pct" outline color="success"
                >{{ $t('giveToCustomer.giveButton') }}</v-btn
              >
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'giveToCustomerModal',
    'closeGiveToCustomerModal',
    'checkAlert',
    'giveData',
    'giveToCustomer',
    'customers'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.giveToCustomer()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/coupons/giveToCustomer.vue